import React from 'react';
import { IsFree } from 'styles/Table.styled';
import { toLocale } from 'utils/filters';

export const storageColumns = [
    {
        Header: '№ komórki',
        accessor: 'storageRoomNumber',
    },
    {
        Header: 'Metraż',
        accessor: 'storageRoomArea',
        Cell: (data: any) => {
            return (
                <span>
                    {data?.cell?.value} m<sup>2</sup>
                </span>
            );
        },
    },
    {
        Header: 'Cena',
        accessor: 'storageRoomPrice',
        Cell: (data: any) => {
            return <span>{toLocale(data?.cell?.value)} zł</span>;
        },
    },
    {
        Header: 'Status',
        accessor: 'storageRoomStatus',
        Cell: (data: any) => {
            return (
                <IsFree isFree={data?.row?.original?.storageRoomStatus}>
                    {data?.row?.original?.storageRoomStatus}
                </IsFree>
            );
        },
    },
    {
        Header: 'Status',
    },
];
